import React from 'react';

import IconButton from '@atlaskit/button/icon/button';
import ArrowLeft from '@atlaskit/icon/core/arrow-left';

import { type DrawerCloseButtonProps } from '../types';
import { useEnsureIsInsideDrawer } from '../use-ensure-is-inside-drawer';
import { useOnClose } from '../use-on-close';

/**
 * __Drawer close button
 *
 * A button that closes the drawer.
 */
export const DrawerCloseButton = ({
	icon: Icon,
	label = 'Close drawer',
	testId = 'DrawerCloseButton',
}: DrawerCloseButtonProps): React.JSX.Element => {
	useEnsureIsInsideDrawer();
	const onClose = useOnClose();

	return (
		<IconButton
			onClick={onClose}
			testId={testId}
			icon={Icon ? (iconProps) => <Icon {...iconProps} size="large" /> : ArrowLeft}
			label={label}
			shape="circle"
			appearance="subtle"
		/>
	);
};
